import Box from "@mui/material/Box";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import PersistentDrawerLeft from "../Drawer/PersistentDrawerLeft";
import AvatarRow from "../AboutMe/AvatarRow";
interface MainTagProps {
  open?: boolean;
}

const styledOptions = {
  shouldForwardProp: (prop: PropertyKey) => prop !== "open",
};

const MainStyled = styled(
  "main",
  styledOptions
)<MainTagProps>(({ theme, open }) => ({
  fontFamily: "Merriweather, serif",
  fontWeight: 400,
  fontStyle: "normal",
  margin: "0px 40px 40px 40px",
  minHeight: "800px",
}));

interface Props {
  children: JSX.Element;
}

export default function Main({ children }: Props): JSX.Element {
  const theme = useTheme();
  const desktopMatch = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <PersistentDrawerLeft />
      <MainStyled>{children}</MainStyled>
      <Box
        sx={
          {
            // alignItems: "center",
            // backgroundColor: "rgb(65, 10, 10)",
            // height: "300px",
            // display: "flex",
            // justifyContent: desktopMatch ? "left" : "center",
            // float: "right",
            // justifyContent: "right",
            // padding: "25px",
          }
        }
      >
        <div
          style={{
            width: "100%",
            height: "5px",
            backgroundColor: "#22311d",
            marginBottom: "25px",
          }}
        ></div>
        <div style={{ margin: "25px" }}>
          <span style={{}}>Connect</span>
          <div
            style={{
              width: "104px",
              height: "1px",
              backgroundColor: "#22311d",
              margin: "10px 0",
            }}
          ></div>
          <AvatarRow fillColor="black" fontSize="small" />
        </div>
      </Box>
    </>
  );
}
